import {createRouter, createWebHistory} from "vue-router";
import Home from "../views/Home.vue";
import Collections from "@/views/CollezioniView.vue";
import Colors from "@/views/ColorsView.vue";
import Finishes from "@/views/FinishesView.vue";
import Producibility from "@/views/ProducibilityView.vue";
import Collection from "@/views/CollezioneView.vue";
import Decor from "@/views/DecorativoView.vue";
import Login from "@/views/Login.vue";
import Stocks from "@/views/StocksView.vue";
import NotFound from "@/components/NotFound.vue";
import Forbidden from "@/components/Forbidden.vue";
import NotAuthorized from "@/components/NotAuthorized.vue";
import store from "@/store";
import Users from "@/views/Users.vue";

const routes = [
    {
        path: "",
        name: "home",
        component: Home,
        meta: {
            requiresAuth: false,
            title: "ABET Toolkit",
        },
    },
    {
        path: "/",
        name: "home",
        component: Home,
        meta: {
            requiresAuth: false,
            title: "ABET Toolkit",
        },
    },
    {
        path: "/collections",
        name: "collections",
        component: Collections,
        meta: {
            requiresAuth: true,
            requiresRoles: ["user", "admin"],
            title: "ABET Collections",
        },
    },
    {
        path: "/collections/:collezione",
        name: "collezione",
        component: Collection,
        meta: {
            requiresAuth: true,
            requiresRoles: ["user", "admin"],
            title: "ABET ",
        },
    },
    {
        path: "/colors",
        name: "colors",
        component: Colors,
        meta: {
            requiresAuth: true,
            requiresRoles: ["admin"],
            title: "ABET Colors",
        },
    },
    {
        path: "/finishes",
        name: "finishes",
        component: Finishes,
        meta: {
            requiresAuth: true,
            requiresRoles: ["admin"],
            title: "ABET Finishes",
        },
    },
    {
        path: "/producibility",
        name: "producibility",
        component: Producibility,
        meta: {
            requiresAuth: true,
            requiresRoles: ["sales", "user", "admin"],
            title: "ABET Producibility",
        },
    },
    {
        path: "/collections/:collezione/:decorativo",
        name: "decor",
        component: Decor,
        meta: {
            requiresAuth: true,
            requiresRoles: ["admin"],
            title: "ABET ",
        },
    },
    {
        path: "/login",
        name: "login",
        component: Login,
        meta: {
            requiresAuth: false,
            title: "ABET Login",
        },
    },
    {
        path: "/stocks",
        name: "stocks",
        component: Stocks,
        meta: {
            requiresAuth: true,
            requiresRoles: ["sales", "user", "admin"],
            title: "ABET Stocks",
        },
    },
    {
        path: "/users",
        name: "users",
        component: Users,
        meta: {
            requiresAuth: true,
            requiresRoles: ["admin"],
            title: "ABET Users",
        }
    },
    {
        path: "/403",
        name: "forbidden",
        component: Forbidden,
        meta: {
            requiresAuth: false,
            title: "403 Forbidden",
        },
    },
    {
        path: "/401",
        name: "not-authorized",
        component: NotAuthorized,
        meta: {
            requiresAuth: false,
            title: "401 Not Authorized",
        },
    },
    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        component: NotFound,
        meta: {
            requiresAuth: false,
            title: "404 Not Found",
        },
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach( (to, from, next) => {
    const provider = store.getters["auth/provider"];
    const isLoggedIn = store.getters["auth/loggedIn"];

    // auth is not required
    if (!to.meta.requiresAuth) {
        return next();
    }

    if (!isLoggedIn) {
        if (provider === 'msal') {
            // acquire the token from Azure
            return store.dispatch("auth/token", {provider})
                .then(() => {
                    return next();
                })
                .catch(() => {
                    // if there is a problem while acquiring the token, let the user log in
                    return store.dispatch("auth/login", {provider})
                        .then(() => {
                            // once the user has logged in, try again to acquire the token
                            // store.dispatch("auth/token", {provider})
                            //     .then(() => {
                            //         return next();
                            //     })
                            //     .catch(() => {
                            //         return next("/login");
                            //     });
                            return next();
                        })
                        .catch(() => {
                            return next("/login");
                        });
                });
        }
        return next("/login");
    }

    store
        .dispatch("auth/role")
        .then((data) => {
            if (to.meta.requiresRoles.includes(data.role)) {
                return next();
            } else {
                return next("/403");
            }
        }).catch(() => {
            return next("/");
        });

});

export default router;
